import React from "react";

const PartnersSectionHeader = ({section, language}) => {
    return section.large ? <h1>{section.title[language]}</h1> : <h2>{section.title[language]}</h2>
}

export default PartnersSectionHeader
